import { isAnalyticsBlocked } from '../components/analytics/analyticsStatus'

// The CSAT form's payload only reaches Segment, so when analytics is blocked a submission would be
// silently dropped. While blocked we hide the entry point entirely rather than collect lost feedback.
export const isCsatAvailable = () => !isAnalyticsBlocked()
